module.exports = __webpack_public_path__ + "img/arrow-left.93ca8be6.svg";